<div class="td-card td-insights-card" *ngIf="insights.length">
  <div class="td-card-header">
    <span class="td-card-title">{{ 'td_team_report_insights' | translate }}</span>
    <button type="button" class="td-insights-see-all" (click)="onSeeAll()">
      <span>{{ 'td_team_report_see_all' | translate }}</span>
      <i class="bi bi-chevron-right"></i>
    </button>
  </div>

  <div class="td-insights-list">
    <div class="td-insight" *ngFor="let insight of insights; trackBy: trackByUuid"
         [ngClass]="{'highlighted': insight.highlighted}">
      <span class="td-insight-icon" [ngStyle]="{'background-color': insight.color}">
        <span class="td-insight-glyph"
              [ngStyle]="{'-webkit-mask-image': 'url(' + insight.icon + ')',
                          'mask-image': 'url(' + insight.icon + ')'}"></span>
        <span class="td-insight-dot" *ngIf="insight.isNew"></span>
      </span>
      <div class="td-insight-text">
        <span class="td-insight-title">{{ insight.title }}</span>
        <span class="td-insight-description">{{ insight.description }}</span>
      </div>
      <button type="button" class="td-insight-dismiss" (click)="onDismiss(insight)">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
  </div>
</div>
